import { render, staticRenderFns } from "./PdfPreview.vue?vue&type=template&id=4fa82696&scoped=true&"
import script from "./PdfPreview.vue?vue&type=script&lang=ts&"
export * from "./PdfPreview.vue?vue&type=script&lang=ts&"
import style0 from "./PdfPreview.vue?vue&type=style&index=0&id=4fa82696&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa82696",
  null
  
)

export default component.exports